import types from './accessTypes.js'
import defaults from './accessDefaults.js'

const mutations = {
  [types.SET_USER_ID](state, payload) {
    state.userId = payload.userId
  },

  [types.CLEAR_USER_ID](state) {
    state.userId = defaults.userId
  },

  [types.SET_ACCOUNT](state, payload) {
    state.account = payload.account
  },

  [types.CLEAR_ACCOUNT](state) {
    state.account = defaults.account
  },

  [types.SET_ACCOUNT_POINTS](state, points) {
    state.reverScore = points
  },

  [types.SET_ORGANIZATION_ID](state, payload) {
    state.organizationId = payload.organizationId
  },

  [types.SET_SITE_ID](state, payload) {
    state.siteId = payload.siteId
  },

  [types.CLEAR_ORGANIZATION_ID](state) {
    state.organizationId = defaults.organizationId
  },

  [types.CLEAR_SITE_ID](state) {
    state.siteId = defaults.siteId
  },

  [types.SET_ORGANIZATION](state, payload) {
    state.organization = payload.organization
  },

  [types.CLEAR_ORGANIZATION](state) {
    state.organization = defaults.organization
  },

  [types.SET_TOKEN](state, payload) {
    localStorage.setItem('token', payload.token)
    state.token = payload.token
  },

  [types.CLEAR_TOKEN](state) {
    localStorage.removeItem('token')
    state.token = defaults.token
  },

  [types.SET_TAGS](state, payload) {
    state.tags = payload.tags
  },

  [types.CLEAR_TAGS](state) {
    state.tags = []
  },

  [types.SET_LOGO](state, payload) {
    state.logoMediaObject = payload
  },

  [types.CLEAR_LOGO](state) {
    state.logoMediaObject = null
  },

  [types.SET_AZURE](state, azureObject) {
    state.azure = azureObject
  },

  [types.UPDATE_ACCOUNT_LOCATION](state, location) {
    state.account.site = location.site
    state.account.tags = location.tags
  },

  updateLocation(state, location) {
    state.account.site = location.site
    state.account.tags = location.tags
  },

  [types.ACCEPT_TERMS_OF_SERVICE](state) {
    state.account.tocsHasAccepted = true
  },

  [types.SET_ORGANIZATION_AI_SETTINGS](state, aiSettings) {
    state.organization = {
      ...state.organization,
      aiSettings,
    }
  },

  [types.SET_ACCOUNT_ORGANIZATIONS](state, { organizations }) {
    state.accountOrganizations = organizations
  },

  [types.CLEAR_ACCOUNT_ORGANIZATIONS](state) {
    state.accountOrganizations = defaults.accountOrganizations
    state.hasFetchedAccountOrganizations =
      defaults.hasFetchedAccountOrganizations
  },

  [types.SET_HAS_FETCHED_ACCOUNT_ORGANIZATIONS](state) {
    state.hasFetchedAccountOrganizations = true
  },

  [types.SET_PENDING_ORG_SWITCH](state, { pendingOrgSwitch }) {
    state.pendingOrgSwitch = pendingOrgSwitch
  },

  [types.CLEAR_PENDING_ORG_SWITCH](state) {
    state.pendingOrgSwitch = defaults.pendingOrgSwitch
  },

  [types.SET_ORG_SWITCH_SPLASH](state, { organizationName = null }) {
    state.isSwitchingOrganizations = true
    state.switchingToOrganizationName = organizationName
  },

  [types.CLEAR_ORG_SWITCH_SPLASH](state) {
    state.isSwitchingOrganizations = defaults.isSwitchingOrganizations
    state.switchingToOrganizationName = defaults.switchingToOrganizationName
  },
}

export default mutations
